/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    WEB_PLANS_RECEIVE,
    WEB_PLANS_REQUEST,
    WEB_PLANS_REQUEST_SUCCESS,
    WEB_PLANS_REQUEST_FAILURE,
    CURRENT_WEB_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [WEB_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [WEB_PLANS_REQUEST]: () => true,
    [WEB_PLANS_REQUEST_SUCCESS]: () => false,
    [WEB_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [WEB_PLANS_REQUEST]: () => false,
    [WEB_PLANS_REQUEST_SUCCESS]: () => false,
    [WEB_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
